import { AmericanLeather } from '../assets/american-leather'
import { Pratt } from '../assets/pratt'
import { SanDiego } from '../assets/san-diego'
import { Sheffield } from '../assets/sheffield'
import { Telus } from '../assets/telus'

export function Customers() {
  return (
    <div className='flex flex-col items-center gap-[48px] pt-0 pb-[100px]'>
      <div className='container flex flex-col'>
        <div className='w-full justify-center gap-[48px] px-[16px] pt-[56px]'>
          <h3 className='mb-0 flex-none text-center text-[36px] leading-[110%] font-[700] tracking-tight text-black max-[991px]:text-[26px] max-[768px]:text-[32px] max-[768px]:w-full'>
            Trusted by users and teams of all sizes
          </h3>
        </div>
      </div>

      <div className='flex w-full flex-row flex-nowrap overflow-hidden'>
        <div className='flex mx-auto max-w-[1080px] flex-wrap gap-[16px] flex-row [&_svg]:mx-auto [&_svg]:h-[44px] [&_svg]:w-[188px] [&_svg]:px-10 [&_svg]:text-gray-400 [&_svg]:transition-colors [&_svg:hover]:text-black'>
          <AmericanLeather />
          <Pratt />
          <SanDiego />
          <Sheffield />
          <Telus />
        </div>
      </div>
    </div>
  )
}
